import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { OfferService } from 'src/app/api/tourism/offer.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.css']
})
export class OfferListComponent implements OnInit {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private offerService: OfferService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.offerService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/turismo/ofertas/editar',
      id
    ]);
  }

  delete(item: any, _index:any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.description,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.offerService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success('El registro '+item.description+' se ha eliminado con éxito');
            this.list();
          }
        });
      }
    });
  }
}
